import { useEffect, useState } from 'react';

export const SPEAKING_VOLUME_LEVEL = 5;
export const VOLUME_DECAY_MS = 1000;

export default function useFakeVolumeLevel(transcript) {
  const [volumeLevel, setVolumeLevel] = useState(0);

  useEffect(() => {
    setVolumeLevel(SPEAKING_VOLUME_LEVEL);
    const decayTimer = setTimeout(() => setVolumeLevel(0), VOLUME_DECAY_MS);
    return () => clearTimeout(decayTimer);
  }, [transcript]);

  return volumeLevel;
}
